var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeRouteinline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 53,
    viewBox: "0 0 48 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_161_716)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 20,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5353 21.922L19.7864 19.5423V31.8088C19.7864 32.1179 20.0234 32.3684 20.3158 32.3684C20.6081 32.3684 20.8452 32.1179 20.8452 31.8088V19.5423L23.0963 21.922C23.3031 22.1406 23.6382 22.1406 23.8449 21.922C24.0517 21.7035 24.0517 21.3492 23.8449 21.1306L20.6901 17.7955C20.4833 17.577 20.1482 17.577 19.9415 17.7955L16.7866 21.1306C16.6574 21.2672 16.609 21.4568 16.6413 21.6332C16.6607 21.739 16.7091 21.8401 16.7866 21.922C16.8125 21.9494 16.8403 21.9733 16.8697 21.9938C17.0752 22.1372 17.3544 22.1133 17.5353 21.922Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4647 28.078L28.2136 30.4577V18.1912C28.2136 17.8821 27.9766 17.6316 27.6842 17.6316C27.3919 17.6316 27.1548 17.8821 27.1548 18.1912V30.4577L24.9037 28.078C24.6969 27.8594 24.3618 27.8594 24.1551 28.078C23.9483 28.2965 23.9483 28.6508 24.1551 28.8694L27.3099 32.2045C27.5167 32.423 27.8518 32.423 28.0585 32.2045L31.2134 28.8694C31.3426 28.7328 31.391 28.5432 31.3587 28.3668C31.3393 28.261 31.2909 28.1599 31.2134 28.078C31.1875 28.0506 31.1597 28.0267 31.1303 28.0062C30.9248 27.8628 30.6456 27.8867 30.4647 28.078Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_161_716",
    x: 0,
    y: 0,
    width: 48,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_161_716"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_161_716",
    result: "effect2_dropShadow_161_716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_161_716",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRouteinline);
export default __webpack_public_path__ + "static/media/change-route.inline.4ab26133f20ce2ad094f34c258783fc2.svg";
export { ForwardRef as ReactComponent };